import MappingRisksTypes from "ContainersForm/MappingRisk/types"

export const postHistoryMapping = payload => ({
  type: MappingRisksTypes.POST_HISTORY_MAPPING,
  payload,
})

export const getHistoryMappingSuccess = payload => ({
  type: MappingRisksTypes.GET_HISTORY_MAPPING_SUCCESS,
  payload,
})

export const getHistoryMapping = payload => ({
  type: MappingRisksTypes.GET_HISTORY_MAPPING,
  payload,
})
